import { BaseTextFieldVariant } from 'core/components/textField/BaseTextFieldVariant.ts';

export const BaseTextFieldConfig = {
	baseTextFieldVariantTypes: [
		BaseTextFieldVariant.STANDARD,
		BaseTextFieldVariant.FILLED,
		BaseTextFieldVariant.OUTLINED,
	],
	defaultVariantType: BaseTextFieldVariant.OUTLINED,
};
